<template lang="pug">
div(:class="{'in-uploader':inUploader}").wrap-atom-expression-texture-changer
  span.label.block.fz14.bold 目
  div.wrap-texture.f.flex-between.flex-wrap.mb8
    div(v-for="texture in eyeIrisTextures"
      @click="onTexture(texture)"
      :class="{ 'active' : addedTextures.includes(texture.name) }"
      ).texture.cursor-pointer
      img(:src="texture.path")
  span.label.block.fz14.bold.mb8 フェイスペイント
  div.wrap-texture.f.flex-between.flex-wrap
    div(v-for="texture in faceSkinTextures"
      :class="{ 'active' : addedTextures.includes(texture.name) }"
      @click="onTexture(texture)").texture.cursor-pointer
      img(:src="texture.path").texture-img
      img(src="/custom-texture/face-skin/base-face.svg").bg
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-atom-expression-texture-changer {
  color: $dark_primary_text_color;
  .wrap-texture {
    .texture {
      position: relative;
      width: 49%;
      img {
        filter: grayscale(1);
      }
      .texture-img {
        position: relative;
        z-index: 1;
      }
      .bg {
        position: absolute;
        width: 100%; height: 100;
        left: 0; top: 0;
        z-index: 0;
      }
      &.active {
        opacity: 0.1;
      }
    }
  }
}
</style>

<script>
import vrmManager from '@/components/mixin/vrmManager'

export default {
  mixins: [vrmManager],
  props: {
    targetObject: {
      type: Object,
      required: true
    },
    targetObjectDoc: {
      type: Object,
      default: null
    },
    clock: {
      type: Object,
      required: true
    },
    isPhotoStudio: {
      type: Boolean,
      default: false,
    },
    inUploader: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addedTextures: []
    }
  },
  computed: {
    vrm () {
      return this.targetObject.userData.vrm
    }
    // addedTextures () {
    //   // let resultTextureNames = []
    //   // const targetFaceSkins = this.faceSkins
    //   //   .filter(f => f.uuid === this.targetObject.uuid)[0]
    //   // if (targetFaceSkins) {
    //   //   const addedLayers = targetFaceSkins.layers
    //   //     .filter(l => l.name !== 'original')
    //   //     .map(l => l.name)
    //   //   resultTextureNames = resultTextureNames.concat(addedLayers) // [ ...addedLayers, ...resultTextureNames ]
    //   // }
    //   // const targetEyeIrises = this.eyeIrises
    //   //   .filter(f => f.uuid === this.targetObject.uuid)[0]
    //   // if (targetEyeIrises) {
    //   //   const addedLayers = targetEyeIrises.layers
    //   //     .filter(l => l.name !== 'original')
    //   //     .map(l => l.name)
    //   //   resultTextureNames = resultTextureNames.concat(addedLayers) // [ ...addedLayers, ...resultTextureNames ]
    //   // }
    //   // // N00_000_00_Face_00_SKIN のmaterialは複数あるので重複が発生する
    //   // resultTextureNames = [ ...new Set(resultTextureNames)]
    //   // console.log('resultTextureNames', resultTextureNames)
    //   // return resultTextureNames

    //   return this.targetObjectDoc.addedCustomTexture ? 
    //     this.targetObjectDoc.addedCustomTexture : []
    // }
  },
  created () {
    if (this.targetObjectDoc && !this.isPhotoStudio) {
      this.addedTextures = this.targetObjectDoc.addedCustomTexture ? 
        this.targetObjectDoc.addedCustomTexture : []
    }
  },
  methods: {
    async onTexture (texture) {
      if (this.addedTextures.includes(texture.name)) {
        this.$emit('removeCustomTextureFromVRM', {
           vrm: this.vrm, delta: this.clock.getDelta(), removingTextureName: texture.name
        })
        this.addedTextures = this.addedTextures.filter(at => at !== texture.name)
        // await this.removeCustomTextureFromVRM({
        //   vrm: this.vrm, delta: this.clock.getDelta(), removingTextureName: texture.name
        // })
      } else {
        this.$emit('addCustomTextureToVRM', {
          vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: texture.name
        })
        this.addedTextures.push(texture.name)
        // await this.addCustomTextureToVRM({ 
        //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: texture.name
        // })
      }

      // photo studioの場合は保存しない
      if (!this.isPhotoStudio) {
        this.$emit('updateObjectDoc', {
          docId: this.targetObject.userData.docId,
          fieldName: 'addedCustomTexture',
          fieldValue: this.addedTextures
          // fieldValue: this.addedTextures.concat(texture.name)
        })
      }
    }
  }
}
</script>
